import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { portalForHostname } from '../utils/portalExperience';

/** The shared application's root is a portal entry point only on a registered host. */
export function PortalRoot({ children }) {
    const portal = portalForHostname();
    if (!portal) return children;
    return <Navigate to={portal.loginPath} replace />;
}

export function PortalAuthAlias({ recovery = false, children }) {
    const portal = portalForHostname();
    const location = useLocation();
    if (!portal) return children;
    const path = recovery ? portal.recoveryPath : portal.loginPath;
    return <Navigate to={`${path}${location.search}${location.hash}`} replace />;
}
